import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "daterangepicker-container" }
const _hoisted_2 = { class: "daterangepicker-section" }
const _hoisted_3 = { class: "daterangepicker-sidebar" }
const _hoisted_4 = { class: "daterangepicker-footer" }

import { onMounted, computed, ref, toRefs, watch } from 'vue';
import Calendar from 'primevue/calendar';
import InputMask from 'primevue/inputmask';
import OverlayPanel from 'primevue/overlaypanel';
import Listbox from 'primevue/listbox';
import { EMIT } from '@/enum';

interface PropsInterface {
  value: string[];
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DateRangePicker',
  props: {
    value: {},
    disabled: { type: Boolean }
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { value, disabled } = toRefs(props);

const emit = __emit;

const dateRanges = [
  { name: 'Today', id: 'T' },
  { name: 'Last 7 Days', id: 'LW' },
  { name: 'Last 28 Days', id: 'LM' },
  { name: 'Last 6 Months', id: 'LSM' },
  { name: 'Last 12 Months', id: 'LTM' },
  { name: 'Year-to-Date', id: 'YTD' },
  { name: 'Current School Year', id: 'CSY' },
  { name: 'Custom Range', id: 'CR' },
];

const selectedDateRange = ref({ name: 'Custom Range', id: 'CR' });

const dates = ref<Date[]>([]);

const firstDate = ref<Date>();

const secondDate = ref<Date>();

const formattedFirstDate = ref<string>('');

const formattedSecondDate = ref<string>('');

let dateFieldTimeout = 0;

const daterangepicker = ref();

onMounted(() => defineDates());

watch(dates, () => {
  if (!dates.value[0]) return;
  selectedDateRange.value = { name: 'Custom Range', id: 'CR' };
  updateDates();
});

watch(value, () => defineDates());

watch(selectedDateRange, () => {
  let newRange = selectedDateRange.value;

  if (newRange && newRange.id) {
    let today = new Date();

    switch (newRange.id) {
      case 'T':
        dates.value[0] = new Date();
        dates.value[1] = new Date();
        break;
      case 'LW':
        // This would be for setting to the last full week (M-F)
        // dates[0] = new Date(
        //   today.setDate(today.getDate() - ((today.getDay() + 6) % 7))
        // );
        // dates[1] = new Date(today.setDate(today.getDate() + 4));
        dates.value[0] = new Date(today.setDate(today.getDate() - 7));
        dates.value[1] = new Date();
        break;
      case 'LM':
        // This would be for setting to the last full month
        // dates[1] = new Date(today.setDate(0));
        // dates[0] = new Date(today.setDate(1));
        dates.value[0] = new Date(today.setDate(today.getDate() - 28));
        dates.value[1] = new Date();
        break;
      case 'LSM':
        dates.value[0] = new Date(today.setMonth(today.getMonth() - 6));
        dates.value[1] = new Date();
        break;
      case 'LTM':
        dates.value[0] = new Date(today.setMonth(today.getMonth() - 12));
        dates.value[1] = new Date();
        break;
      case 'YTD':
        today.setMonth(today.getMonth() - today.getMonth());
        today.setDate(1);
        dates.value[0] = new Date(today);
        dates.value[1] = new Date();
        break;
      case 'CSY':
        if (today.getMonth() <= 7) {
          today.setFullYear(today.getFullYear() - 1);
        }
        today.setMonth(7);
        today.setDate(1);
        dates.value[0] = new Date(today);
        dates.value[1] = new Date();
        break;
      default:
        break;
    }

    updateDates();
  }
});

const defaultDateRange = computed(() => {
  return firstDate.value
    ? firstDate.value.toLocaleDateString('en-US') +
        ' - ' +
        (secondDate.value ? secondDate.value.toLocaleDateString('en-US') : ' ')
    : null;
});

const defineDates = () => {
  if (value.value[0]) {
    dates.value[0] = new Date(value.value[0]);
    firstDate.value = new Date(dates.value[0]);
  }
  if (value.value[1]) {
    dates.value[1] = new Date(value.value[1]);
    secondDate.value = new Date(dates.value[1]);
  }
};

const toggleDateRangePicker = (event: Event) => {
  daterangepicker.value.toggle(event);
  emit(EMIT.BLUR);
};

const formatDate = (date: Date) => {
  let d = date.getDate();
  let dayString = d < 10 ? '0' + d : d.toString();
  let m = date.getMonth() + 1;
  let monthString = m < 10 ? '0' + m : m.toString();
  let y = date.getFullYear();

  return `${monthString}${dayString}${y}`;
};

const updateFromField = (field: number) => {
  if (dateFieldTimeout) clearTimeout(dateFieldTimeout);

  dateFieldTimeout = setTimeout(() => {
    let dateBeingUpdated = field === 0 ? formattedFirstDate.value : formattedSecondDate.value;

    if (!/[a-z]/i.test(dateBeingUpdated)) {
      dates.value[field] = new Date(dateBeingUpdated);
    }
  }, 500);
};

const updateDates = () => {
  formattedFirstDate.value = dates.value[0] ? formatDate(dates.value[0]) : '';
  formattedSecondDate.value = dates.value[1] ? formatDate(dates.value[1]) : '';
};

const applyDates = () => {
  firstDate.value = dates.value[0];
  secondDate.value = dates.value[1];
  emit(EMIT.CHANGE, dates.value);
  emit(EMIT.BLUR);
  daterangepicker.value.hide();
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IconField, { "icon-position": "left" }, {
      default: _withCtx(() => [
        _createVNode(_component_InputIcon, { class: "pi p-input-icon-left" }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              name: "calendar_today",
              class: "text-lg z-1"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_InputText, {
          class: "w-full",
          value: defaultDateRange.value,
          disabled: _unref(disabled),
          placeholder: "Select a Date",
          onClick: toggleDateRangePicker
        }, null, 8, ["value", "disabled"])
      ]),
      _: 1
    }),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "daterangepicker",
      ref: daterangepicker,
      onHide: _cache[6] || (_cache[6] = () => emit(_unref(EMIT).BLUR))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Calendar), {
            id: "basic",
            modelValue: dates.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dates).value = $event)),
            "selection-mode": "range",
            inline: true
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Listbox), {
              modelValue: selectedDateRange.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDateRange).value = $event)),
              options: dateRanges,
              "option-label": "name"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(InputMask), {
            modelValue: formattedFirstDate.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formattedFirstDate).value = $event)),
            type: "text",
            mask: "99/99/9999",
            placeholder: "xx/xx/xxxx",
            "slot-char": "mm/dd/yyyy",
            "auto-clear": false,
            onKeyup: _cache[3] || (_cache[3] = ($event: any) => (updateFromField(0)))
          }, null, 8, ["modelValue"]),
          _cache[7] || (_cache[7] = _createTextVNode(" - ", -1)),
          _createVNode(_unref(InputMask), {
            modelValue: formattedSecondDate.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formattedSecondDate).value = $event)),
            type: "text",
            mask: "99/99/9999",
            placeholder: "xx/xx/xxxx",
            "slot-char": "mm/dd/yyyy",
            "auto-clear": false,
            onKeyup: _cache[5] || (_cache[5] = ($event: any) => (updateFromField(1)))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_AppButton, {
            text: "Cancel",
            type: "secondary",
            onClick: toggleDateRangePicker
          }),
          _createVNode(_component_AppButton, {
            text: "Apply",
            onClick: applyDates
          })
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})